import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import useWorkspacePermittedData from "../WorkspaceManagement/services/useWorkspacePermittedData";
import constants from "../../utils/constants";
import useCsvUpload from "../../hooks/useCsvUpload";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleCheck, faCircleExclamation, faEye } from "@fortawesome/pro-regular-svg-icons";
import SelectWorkspace from "../SelectWorkspace";
import CSVModal from "../CSVModal";
import { useAuth } from "@qure/qure-auth";
function LogsView() {
  var _state$result, _state$result2;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useWorkspacePermitte = useWorkspacePermittedData(true, constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_WRITE),
    data = _useWorkspacePermitte.data,
    isLoading = _useWorkspacePermitte.isLoading;
  var _useState = useState(null),
    selectedWorkspace = _useState[0],
    setSelectedWorkspace = _useState[1];
  var _useState2 = useState(null),
    selectedFile = _useState2[0],
    setSelectedFile = _useState2[1];
  var listOfWorkspacesRef = useRef();
  var ranOnceRef = useRef(false);
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    state = _useCsvUpload2[0],
    dispatch = _useCsvUpload2[1];
  useEffect(function () {
    var _data$filter, _listSource$find;
    if (isLoading) return;
    var listSource = data === null || data === void 0 || (_data$filter = data.filter(function (src) {
      return !src.data_hidden;
    })) === null || _data$filter === void 0 ? void 0 : _data$filter.map(function (src) {
      return {
        label: src.name,
        value: src.id,
        id: src.uuid,
        role: src.role,
        has_permission: src.has_permission,
        synced: src.synced
      };
    });
    var defaultWorkspace = (_listSource$find = listSource === null || listSource === void 0 ? void 0 : listSource.find(function (item) {
      return String(item.value) === String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
    })) !== null && _listSource$find !== void 0 ? _listSource$find : null; //  this is bad

    setSelectedWorkspace(defaultWorkspace);
    listOfWorkspacesRef.current = listSource;
    if (defaultWorkspace) {
      if (!ranOnceRef.current) {
        ranOnceRef.current = true;
        dispatch({
          type: "get-logs",
          payload: {
            selectedWorkspace: defaultWorkspace
          }
        });
      }
    }
  }, [isLoading]);
  if (isLoading) {
    return;
  }
  if (!listOfWorkspacesRef.current) {
    return;
  }
  var handlePreview = function handlePreview(file) {
    setSelectedFile(file);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CSVModal, {
    selectedFile: selectedFile,
    setSelectedFile: setSelectedFile
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col justify-start py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex px-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-4"
  }, /*#__PURE__*/React.createElement(SelectWorkspace, {
    selectedSource: selectedWorkspace,
    setSelectedSource: function setSelectedSource(x) {
      setSelectedWorkspace(x);
      dispatch({
        type: "get-logs",
        payload: {
          selectedWorkspace: x
        }
      });
    },
    siteOptions: listOfWorkspacesRef.current
  }))), ((_state$result = state.result) === null || _state$result === void 0 || (_state$result = _state$result.data) === null || _state$result === void 0 ? void 0 : _state$result.length) !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[400px,100px,200px] gap-x-3 text-left px-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "File Name"), /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "MRN"), /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "Status"), (_state$result2 = state.result) === null || _state$result2 === void 0 || (_state$result2 = _state$result2.data) === null || _state$result2 === void 0 ? void 0 : _state$result2.map(function (item, idx) {
    var _state$result3, _item$summary, _item$summary2, _item$summary3;
    var isLastIndex = idx === (state === null || state === void 0 || (_state$result3 = state.result) === null || _state$result3 === void 0 || (_state$result3 = _state$result3.data) === null || _state$result3 === void 0 ? void 0 : _state$result3.length) - 1;
    var isValidFile = Object.keys(item.summary).length !== 0;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "h-[40px] content-center overflow-clip text-left"
    }, item.original_file_name, " ", (item === null || item === void 0 ? void 0 : item.presigned_url) && /*#__PURE__*/React.createElement("span", {
      onClick: function onClick() {
        return handlePreview(item === null || item === void 0 ? void 0 : item.presigned_url);
      },
      className: "text-gray-500 text-sm ml-2",
      title: "Preview"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      className: "cursor-pointer hover:text-teal-100 text-teal-200 ml-2",
      name: faEye
    }))), /*#__PURE__*/React.createElement("p", {
      className: "h-[40px] content-center text-left"
    }, item.summary.new_patient_reports), /*#__PURE__*/React.createElement("span", {
      className: "h-[40px] items-center inline-flex gap-2"
    }, isValidFile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleCheck,
      className: "text-teal-400 mr-2 pt-1"
    }), /*#__PURE__*/React.createElement("p", null, "Valid Format")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleExclamation,
      className: "text-red-400 mr-2 pt-1"
    }), /*#__PURE__*/React.createElement("p", null, "Invalid Format"))), isValidFile && /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-[300px,100px] py-5 text-left"
    }, /*#__PURE__*/React.createElement("p", {
      className: ""
    }, "Patients to be created"), /*#__PURE__*/React.createElement("p", {
      className: ""
    }, (_item$summary = item.summary) === null || _item$summary === void 0 ? void 0 : _item$summary.new_patient_reports), /*#__PURE__*/React.createElement("p", {
      className: ""
    }, "Existing patient to be updated"), /*#__PURE__*/React.createElement("p", {
      className: ""
    }, (_item$summary2 = item.summary) === null || _item$summary2 === void 0 ? void 0 : _item$summary2.existing_patients), /*#__PURE__*/React.createElement("p", {
      className: ""
    }, "Failed entries"), /*#__PURE__*/React.createElement("p", {
      className: ""
    }, (_item$summary3 = item.summary) === null || _item$summary3 === void 0 ? void 0 : _item$summary3.invalid_patient_reports)), !isLastIndex && /*#__PURE__*/React.createElement("hr", {
      className: "col-span-3 h-[1px] border-t-gray-700"
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "h-[200px] flex justify-center items-center text-gray-600"
  }, "No logs found")));
}
export default LogsView;